import Title from '../Components/Title'

type Props = {}

const FAQPage = (props: Props) => {
  return (
    <Title text={"Perguntas"} />
  )
}

export default FAQPage